"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFileSize = void 0;
var sizes = ['Bytes', 'KBytes', 'MBytes'];
/**
 * Function accepts file size in bytes as a string value and returns formatted results with text suffix
 * @param {string} bytes size
 */
var formatFileSize = function (bytes) {
    if (!bytes) {
        return '';
    }
    var bytesNumber = parseFloat(bytes);
    var i = Math.floor(Math.log(bytesNumber) / Math.log(1024));
    return "".concat(Math.round(bytesNumber / Math.pow(1024, i)), " (").concat(sizes[i], ")");
};
exports.formatFileSize = formatFileSize;
